module.exports = __webpack_public_path__ + "static/media/2.1ca189a9.png";